import * as React from 'react';
import InputHandler from 'Components/InputHandler';
import { fm } from 'Components/FormatMessage';
import type { TESSearchFields } from '../../definitions';
import type { IExtendedSearchField } from '../ExtendedSearchField';
import DateRangeField from './DateRangeField';

const IncludeDeceasedField = ({ searchFields, onChange, value }: IOwnProps): React.JSX.Element => {
  const deathDateField: IExtendedSearchField['field'] = { name: 'deathDate', type: 'Custom' };
  return (
    <React.Fragment>
      <InputHandler
        type="Radio"
        editing={true}
        name="includeDeceased"
        formData={{
          onChange,
          document: { includeDeceased: value },
        }}
        options={['yes', 'yesOnlyDeceased', 'no']}
        optionFormatter={(name: string | number): string | React.JSX.Element => fm(`extendedSearch.opts.${name}`)}
      />
      {typeof value === 'string' && ['yes', 'yesOnlyDeceased'].includes(value) && (
        <DateRangeField {...{ field: deathDateField, onChange, value: searchFields.deathDate }} />
      )}
    </React.Fragment>
  );
};

interface IOwnProps extends Pick<IExtendedSearchField, 'searchFields' | 'onChange'> {
  value: TESSearchFields[keyof TESSearchFields];
}

export default IncludeDeceasedField;
